import React from "react";
import Header from "../../components/header";
import Footer from "../../components/footer";
import AppButton from "../../components/button/component";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { APP_NAVIGATION, LOCALE } from "../../utils/constants";
import PathHelper from "../../utils/path-helper";
import { useParams } from "react-router-dom";
import { getCookie } from "../../utils/utility-functions";

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { locale } = useParams();
  const currentLocale = locale ?? LOCALE.EN;
  const token = getCookie("jwtToken");

  // Get navigation paths
  const homePath = PathHelper(APP_NAVIGATION.ROOT_HOME, currentLocale);
  const dashboardPath = PathHelper(APP_NAVIGATION.DASHBOARD, currentLocale);

  const handleGoHome = () => {
    navigate(dashboardPath.next);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex-1 overflow-y-auto">
        <div className="p-5 text-center bg-white min-h-full flex flex-col justify-center items-center">
          <div className="max-w-md mx-auto">
            {/* 404 Icon/Illustration */}
            <div className="mb-8">
              <div className="text-[150px] font-bold text-insightful-purple">
                404
              </div>
              <div className="text-4xl ">🔍</div>
            </div>

            {/* Error Message */}
            <h1 className="font-bold color-[#444C5E] text-3xl mb-4">
              {t("notFound.page_not_found")}
            </h1>

            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              {t("notFound.error_description")}
            </p>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <AppButton
                onClick={handleGoBack}
                className="bg-gray-500 hover:bg-gray-600 text-white px-6 py-3 rounded-lg font-medium transition-colors"
              >
                {t("notFound.go_back")}
              </AppButton>

              <AppButton
                onClick={handleGoHome}
                className="bg-[#FE6634] hover:bg-orange-700 text-white px-6 py-3 rounded-lg font-medium transition-colors"
              >
                {t("notFound.go_home")}
              </AppButton>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;
